import { Row, Col } from "antd"
import classNames from "classnames/bind"
import i18n from "i18next"
import { Link } from "react-router-dom"
import { withTranslation, TFunction } from "react-i18next"

import { SvgIcon } from "../../common/SvgIcon"
import { ReactComponent as NavbarLogo } from "../../assets/logo-name.svg"
import { MAIN_EMAIL } from "../../content/constants"
import styles from "./styles.scss"

interface SocialLinkProps {
  href: string
  src: string
}

const cx = classNames.bind(styles)
const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language)
  }

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    )
  }

  return (
    <>
      <footer className={cx("footer-section")}>
        <div className={cx("main-container")}>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <h4 className={cx("title")}>{t("Contact")}</h4>
              <div className={cx("footer-title")} >{t("Tell us everything")}</div>
              <div className={cx("body")}>
                {t(`Do you have any question? Feel free to reach out.`)}
              </div>
              <div className={cx("footer-title")}>{t(`Let's Chat`)}</div>
              <a href={`mailto:${MAIN_EMAIL}`}>
                <div className={cx("email")}>
                  {MAIN_EMAIL}
                </div>
              </a>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <label className={cx("footer-label")} htmlFor="select-lang">{t("Language")}</label>
              <div className={cx("language-switch-container")}>
                <div className={cx("language-switch")} onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </div>
                <div className={cx("language-switch")} onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </div>
              </div>
            </Col>
            <Col className={cx("hide-col")} lg={8} md={8} sm={12} xs={12}>
              <h4 className={cx("title")}>{t("Policy")}</h4>
              <Link className={cx("label-link")} to="/">{t("Application Security")}</Link>
              <Link className={cx("label-link")} to="/">{t("Software Principles")}</Link>
            </Col>
            <Col className={cx("hide-col")} lg={6} md={6} sm={12} xs={12}>
              <div className={cx("empty")} />
              <Link className={cx("label-link")} to="/">{t("Support Center")}</Link>
              <Link className={cx("label-link")} to="/">{t("Customer Support")}</Link>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col className={cx("hide-col")} lg={10} md={10} sm={12} xs={12}>
              <div className={cx("empty")} />
              <h4 className={cx("language")}>{t("Address")}</h4>
              <div className={cx("body")}>123</div>
              <div className={cx("body")}>456</div>
              <div className={cx("body")}>789</div>
            </Col>
            <Col className={cx("hide-col")} lg={8} md={8} sm={12} xs={12}>
              <h4 className={cx("title")}>{t("Company")}</h4>
              <Link className={cx("label-link")} to="/">{t("About")}</Link>
              <Link className={cx("label-link")} to="/">{t("Careers & Culture")}</Link>
            </Col>

          </Row>
        </div>
      </footer>
      <section className={cx("extra")}>
        <div className={cx("main-container")}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
          <div className={cx("main-logo")}>
            <Link to="/" aria-label="homepage">
              <NavbarLogo/>
            </Link>
          </div>
            <div className={cx("hide-col","footerContainer")}>
              <SocialLink
                href="https://github.com"
                src="github.svg"
              />
              <SocialLink
                href="https://x.com"
                src="twitter.svg"
              />
              <SocialLink
                href="https://www.linkedin.com"
                src="linkedin.svg"
              />
            </div>
          </Row>
        </div>
      </section>
    </>
  )
}

export default withTranslation()(Footer)
